import { clean as o } from "@liff/store";

function f() {
  o();
}

export { f as logout };